import {FC, PropsWithChildren, useMemo} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {getDateTimeStringWithSecs} from '@kcast-fe/core';

interface IProps extends PropsWithChildren {
  isMyMsg: boolean;
  isMsgHasText: boolean;
  isMsgHasImages?: boolean;
  isMsgHasVideos?: boolean;
  createdAt: string;
}

const WrapperForTextTypeFC: FC<IProps> = ({
  isMyMsg,
  isMsgHasText,
  isMsgHasImages,
  isMsgHasVideos,
  createdAt,
  children
}) => {
  const wrapperPadding: string = useMemo(() => {
    if ((isMsgHasImages || isMsgHasVideos) && isMsgHasText) {
      return '0 0 4px 0';
    } else {
      return '4px 16px';
    }
  }, [isMsgHasImages, isMsgHasVideos, isMsgHasText]);

  /* RENDER ONLY IMAGES WITHOUT TEXT */
  if (isMsgHasImages && !isMsgHasText) {
    return (
      <Box position={'relative'} maxW={'60%'}>
        {children}
      </Box>
    );
  }

  return (
    <Box
      w={'fit-content'}
      maxW={isMyMsg ? '80%' : '100%'}
      p={wrapperPadding}
      position={'relative'}
      borderRadius={'24px'}
      lineHeight={{base: '24px'}}
      border={!isMyMsg ? undefined : 'thin solid'}
      borderColor={!isMyMsg ? undefined : '{colors.borderDefault}'}
      color={'{colors.textPrimary}'}
      bg={isMyMsg ? '{colors.bgSurface}' : 'white'}
      shadow={isMyMsg ? '{shadows.msg_2}' : '{shadows.msg_1}'}
      className={'group'}
    >
      {children}
      <Flex
        justifyContent={'flex-end'}
        color={'{colors.textTertiary}'}
        fontSize={'13px'}
        pr={isMsgHasImages || isMsgHasVideos ? '16px' : 0}
      >
        {getDateTimeStringWithSecs(createdAt)}
      </Flex>
    </Box>
  );
};

export const WrapperForTextType = WrapperForTextTypeFC;
